import React, { useState, useEffect } from "react";
import { collection, getDocs, query, orderBy, doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useAuth, db } from "../context/authContext";
import toast from "react-hot-toast";
import logo from "../assets/Logo.png";
import { volverAClase } from "../utils/navigation";

const MENSAJES = [
  "💣 Lo que no hagas ahora, ¡no lo harás nunca!",
  "🔥 Cuando más comas, más tendrás que entrenar!",
  "💤 Descansa... que luego nos veremos en la bici!",
  "🚴‍♂️ Deja el sofá, que aquí se gana en el pedaleo!",
  "💪 Hoy sudas, mañana brillas!",
  "🥵 Si no duele, no sirve!",
  "🏆 El podio no espera a los flojos!",
  "⏱️ El tiempo corre... ¿y tú?",
  "🍔 Cada hamburguesa pesa en tus RPM!",
  "⚡ Dale caña, que la vida no tiene replay!",
];

const Ranking = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [mesActual, setMesActual] = useState("");
  const navigate = useNavigate();
  const { logout, EstadoLogout, addInfoGym, user } = useAuth();

  const handleLogout = async () => {
    try {
      await addInfoGym("");
      localStorage.removeItem("gimnasio");
      await EstadoLogout();

      // 🔄 Notificar logout a otras pestañas
      localStorage.setItem("logout", Date.now());

      // 🚪 Cerrar sesión en Firebase
      await logout();

      console.log("✅ Logout completo y propagado desde Ranking");
    } catch (error) {
      console.error("❌ Error en logout:", error);
    }
  };

  const handleClase = async () => {
    try {
      localStorage.removeItem("gimnasio");
      await EstadoLogout();
      navigate("/Comprobacion");
    } catch (error) {
      console.error(error);
    }
  };

  // Validar que estoy en ranking
  useEffect(() => {
    localStorage.setItem("lastPage", "ranking");
  }, []);

  // fetchUsuarios
  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const fecha = new Date();
        const nombreMes = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(fecha);
        const mesHoy = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);
        setMesActual(mesHoy);

        // 🔹 Documento global del ranking mensual
        const rankingRef = doc(db, "config", "rankingMensual");
        const rankingSnap = await getDoc(rankingRef);

        let mesActivo = mesHoy;

        if (!rankingSnap.exists()) {
          await setDoc(rankingRef, {
            mesActivo: mesHoy,
            updatedAt: Date.now(),
          });
          mesActivo = mesHoy;
        } else {
          const rankingData = rankingSnap.data();

          if (rankingData.mesActivo !== mesHoy) {
            await setDoc(
              rankingRef,
              {
                mesActivo: mesHoy,
                updatedAt: Date.now(),
              },
              { merge: true }
            );
            mesActivo = mesHoy;
          } else {
            mesActivo = rankingData.mesActivo;
          }
        }

        const usuariosRef = collection(db, "usuarios");
        const q = query(usuariosRef, orderBy("puntosTotales", "desc"));
        const usuariosSnapshot = await getDocs(q);

        const usuariosData = usuariosSnapshot.docs.map((docSnap) => {
          const data = docSnap.data();

          const puntosTotales =
            data.mesReseteado === mesActivo ? (data.puntosTotales || 0) : 0;

          return {
            id: docSnap.id,
            ...data,
            puntosTotales,
          };
        });

        // 🔹 Reordenar según los puntos ya reseteados lógicamente
        usuariosData.sort((a, b) => (b.puntosTotales || 0) - (a.puntosTotales || 0));

        setUsuarios(usuariosData);

        // Mensaje motivacional
        const randomMsg = MENSAJES[Math.floor(Math.random() * MENSAJES.length)];
        toast(randomMsg, {
          icon: "🚀",
          style: {
            borderRadius: "10px",
            background: "#111",
            color: "#fff",
            fontWeight: "bold",
          },
        });
      } catch (error) {
        console.error("❌ Error al obtener usuarios:", error);
      }
    };

    fetchUsuarios();
  }, []);

  const podio = usuarios.slice(0, 3);
  const resto = usuarios.slice(3);

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex flex-col items-center text-white">
      {/* Logo */}
      <div className="text-center mt-6">
        <img src={logo} alt="Logo" className="mx-auto w-40" />
        <p className="text-lg font-bold italic">🏆 Ranking mensual</p>
      </div>

      {/* Mes actual */}
      <h2 className="text-2xl font-extrabold text-center mb-6">
        Clasificación {mesActual}
      </h2>

      {/* Podio */}
      <div className="flex justify-center items-end gap-6 mb-10 w-full max-w-md">
        {podio[1] && (
          <div className="bg-gradient-to-t from-gray-700 to-gray-400 w-28 h-44 rounded-2xl flex flex-col items-center justify-center shadow-lg">
            <span className="text-3xl">🥈</span>
            <p className="font-semibold text-sm truncate">{podio[1].nombre}</p>
            <p className="font-bold">{podio[1].puntosTotales} pts</p>
          </div>
        )}
        {podio[0] && (
          <div className="bg-gradient-to-t from-yellow-600 to-yellow-300 w-32 h-52 rounded-2xl flex flex-col items-center justify-center shadow-xl scale-110">
            <span className="text-4xl">🥇</span>
            <p className="font-bold text-base truncate">{podio[0].nombre}</p>
            <p className="font-bold">{podio[0].puntosTotales} pts</p>
          </div>
        )}
        {podio[2] && (
          <div className="bg-gradient-to-t from-orange-700 to-orange-300 w-28 h-40 rounded-2xl flex flex-col items-center justify-center shadow-lg">
            <span className="text-3xl">🥉</span>
            <p className="font-semibold text-sm truncate">{podio[2].nombre}</p>
            <p className="font-bold">{podio[2].puntosTotales} pts</p>
          </div>
        )}
      </div>

      {/* Lista resto */}
      <div className="w-full max-w-md px-4 mb-8">
        {resto.map((usuario, index) => (
          <div
            key={usuario.id}
            className="bg-white/10 backdrop-blur-md rounded-lg p-3 flex justify-between items-center shadow-sm mb-2"
          >
            <span className="font-medium text-sm truncate flex items-center gap-2">
              <span className="bg-gray-700 text-white w-6 h-6 flex items-center justify-center rounded-full text-xs">
                {index + 4}
              </span>
              {usuario.nombre}
            </span>
            <span className="font-bold text-green-400">{usuario.puntosTotales} pts</span>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="grid grid-cols-2 gap-3 w-full max-w-md px-4 mb-10">
        <button
          onClick={() => volverAClase(navigate, user?.uid)}
          className="bg-gradient-to-r from-yellow-400 to-orange-600 hover:from-yellow-500 hover:to-orange-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Volver
        </button>

        <button
          onClick={handleClase}
          className="bg-gradient-to-r from-blue-400 to-indigo-600 hover:from-blue-500 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition "
        >
          Volver al listado
        </button>

        <button
          onClick={handleLogout}
          className="bg-gradient-to-r from-red-400 to-red-700 hover:from-red-500 hover:to-red-800 text-white font-semibold py-3 rounded-xl shadow-lg transition col-span-2"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Ranking;